module.exports = __webpack_public_path__ + "media/images/help_correction_1-002a2bd49550c89af1e6aaf8a81e7491.png";